import Vue from 'vue'
import axios from 'axios'
import Vuex from 'vuex'
import Session from './session'
import Alertas from './alertas'
import Permisos from './permisos'
import Toast from './toast'
import Contextual from './contextual'
import Notificaciones from './notificaciones'
import Top from './top'

axios.defaults.baseURL = '/src/modulos/'

Vue.prototype.$http = axios

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		session: Session,
		alertas: Alertas,
		permisos: Permisos,
		toast: Toast,
		contextual: Contextual,
		top: Top,
		notificaciones: Notificaciones
	}
})



// WEBPACK FOOTER //
// ./src/modulos/core/vue/store/stores.js